import {
  getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { PostApiV1ThreeLetterCodeClientAdminsCardRegistrations201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

/**
 * SetupIntent 発行 API を実行するカスタムフック。
 * カード変更フォーム用に Stripe の SetupIntent を発行し、Payment Element で使う client_secret を返す。
 *
 * @param threeLetterCode - パートナーコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック（client_secret は data.card_registration.client_secret で取得する）
 * @param options.onError - エラー時のコールバック
 */
export const usePostClientAdminsCardRegistrations = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodeClientAdminsCardRegistrations201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsCardRegistrationsMutationFetcher(threeLetterCode),
    options
  );
};
